import React, { useRef } from "react";
// components
import About from "./components/About";
import Banner from "./components/Banner";
import Contact from "./components/Contact";
import Nav from "./components/Nav";
import Services from "./components/Services";
import Work from "./components/Work";

const App = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="relative bg-ivory overflow-hidden grain">
      <Nav />
      <Banner scrollToContact={scrollToContact} />
      <About scrollToContact={scrollToContact} />
      <Services />
      <Work />
      <div ref={contactRef}>
        <Contact />
      </div>
    </div>
  );
};

export default App;
